import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar colaboradores empresas
export const listarColaboradores = async (empId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/empresas/${empId}/colaboradores`);
};

// Criar colaborador
export const criarColaborador = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/colaboradores/cria-colaborador`,
    payload
  );
};

// Atualizar colaborador
export const atualizarColaborador = async (
  colaboradorId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/colaboradores/${colaboradorId}/atualiza-colaborador`,
    payload
  );
};

// Deletar colaborador
export const deletarColaborador = async (
  colaboradorId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/colaboradores/${colaboradorId}/remove-colaborador`
  );
};
